module.exports = __webpack_public_path__ + "img/heat.1572eb37.png";